<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex" [resizeHorizontal]="resizeHorizontal"
    [resizeHorizontalMin]="500" [resizeVertical]="resizeVertical" [resizeVerticalMin]="600" [maximizable]="maximizable"
    [maximizableAutoId]="modalAutomationId">
    <div class="modal-row-column-auto filterClass">
        <res-filter [filterInputAutoId]="modalAutomationId" [clearButtonDataAutoId]="modalAutomationId" [maxChars]=32
            [placeholder]='"Filter..."' [callback]="filterData.bind(this)" [autofocusInput]="inputAutoFocused"></res-filter>
    </div>
    <div class="modal-fill tree-column" [ngClass]='[targetType == "selection" ? "selection-window" : ""]'>
        <res-generic-tree [automationId]="modalAutomationId + '-tree'"
            customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders"
            [selectedNodeChangedCallback]="selectedNodeChangedCallback" [checkPermissions]="true"></res-generic-tree>
    </div>
    <div class="modal-row path-area" [hidden]='targetType == "selection"'>
        <div class="modal-row-column-auto">
            <res-custom-checkbox automationId="add-to-remove-from-location-include-families"
                [(ngModel)]="includeFamilies" content="Include Families"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>